import { Grid } from "@material-ui/core";

export const DotElastic = () => {
	return (
		<Grid className="row">
			<Grid className="col-3">
				<Grid className="snippet" data-title=".dot-elastic">
					<Grid className="stage">
						<Grid className="dot-elastic"></Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export const DotPulse = () => {
	return (
		<Grid className="row">
			<Grid className="col-3">
				<Grid className="snippet" data-title=".dot-pulse">
					<Grid className="stage">
						<Grid className="dot-pulse"></Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export const DotFalling = () => {
	return (
		<Grid className="row">
			<Grid className="col-3">
				<Grid className="snippet" data-title=".dot-falling">
					<Grid className="stage">
						<Grid className="dot-falling"></Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export const DotSpin = () => {
	return (
		<Grid className="row">
			<Grid className="col-3">
				<Grid className="snippet" data-title=".dot-spin">
					<Grid className="stage">
						<Grid className="dot-spin"></Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
